import { render, staticRenderFns } from "./HeaderDealer.vue?vue&type=template&id=6676dee0&scoped=true&"
import script from "./HeaderDealer.vue?vue&type=script&lang=js&"
export * from "./HeaderDealer.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDealer.vue?vue&type=style&index=0&id=6676dee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676dee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VContainer,VNavigationDrawer,VSpacer})
